export default {
    errorMsg: "데이터 에러, 다시 접속해 주세요"
}